// components/ProductAmountsSection.jsx - Multi-Product Amounts Entry
import React from 'react'
import { X } from 'lucide-react'

export default function ProductAmountsSection({
  selectedProducts,
  productAmounts,
  updateProductAmount,
  removeProduct
}) {
  if (!selectedProducts || selectedProducts.length === 0) {
    return null
  }

  return (
    <div className="space-y-3">
      <h4 className="text-sm font-medium text-gray-700">Product Amounts</h4>

      {selectedProducts.map((productName) => {
        const productData = productAmounts[productName] || { amount: '', unit: 'oz' }

        return (
          <div
            key={productName}
            className="p-4 border border-gray-200 rounded-lg bg-gray-50 space-y-3"
          >
            {/* Product name with remove button */}
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="font-medium text-gray-900">{productName}</span>
              </div>
              <button
                onClick={() => removeProduct(productName)}
                className="p-1 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors"
                title="Remove product"
              >
                <X className="w-4 h-4" />
              </button>
            </div>

            {/* Amount and Unit */}
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="form-label">Amount <span className="text-red-500">*</span></label>
                <input
                  type="number"
                  step="0.01"
                  value={productData.amount}
                  onChange={(e) => updateProductAmount(productName, 'amount', e.target.value)}
                  className="form-input"
                  placeholder="e.g., 12"
                  required
                />
              </div>

              <div>
                <label className="form-label">Unit <span className="text-red-500">*</span></label>
                <select
                  value={productData.unit}
                  onChange={(e) => updateProductAmount(productName, 'unit', e.target.value)}
                  className="form-input"
                  required
                >
                  <optgroup label="Volume">
                    <option value="mL">mL (milliliters)</option>
                    <option value="L">L (liters)</option>
                    <option value="fl oz">fl oz (fluid ounces)</option>
                    <option value="pt">pt (pints)</option>
                    <option value="qt">qt (quarts)</option>
                    <option value="gal">gal (gallons)</option>
                  </optgroup>
                  <optgroup label="Weight">
                    <option value="g">g (grams)</option>
                    <option value="kg">kg (kilograms)</option>
                    <option value="oz">oz (ounces)</option>
                    <option value="lb">lb (pounds)</option>
                  </optgroup>
                </select>
              </div>
            </div>
          </div>
        )
      })}

      <p className="text-xs text-gray-500 mt-2">
        Carrier/diluent information applies to all products and will be entered below.
      </p>
    </div>
  )
}
